import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { BrandLogo, ThemeToggle } from "../../../shared/components";
import { ROUTES } from "../../../shared/utils";

export const AuthCardTopBar: React.FC = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    }}
  >
    <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}>
      <Box
        component={RouterLink}
        to={ROUTES.LOGIN}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          textDecoration: "none",
          color: "inherit",
        }}
      >
        <BrandLogo />
      </Box>
    </Box>
    <ThemeToggle />
  </Box>
);

interface AuthCardIntroProps {
  title: string;
  subtitle: React.ReactNode;
}

export const AuthCardIntro: React.FC<AuthCardIntroProps> = ({
  title,
  subtitle,
}) => (
  <Stack spacing={1}>
    <Typography variant="h5" component="h1" fontWeight={600}>
      {title}
    </Typography>
    <Typography variant="body2" color="text.secondary">
      {subtitle}
    </Typography>
  </Stack>
);
